import React from "react";
import "../../../styles/ToDoList.css";
import { withNamespaces } from 'react-i18next'; 

const Preparar = ({t}) => {
  return (
    <>
        <div className="col-12 col-lg prepararCard">
          <div id="1" className="fantasmaAncora"></div>
          <div className="card">
            <div id="preparar" className="card-body">
              {/* superior */}
              <div className="info">
                <h4 className="title">{t('moduleToDoList:S1.T')}</h4>
              </div>
              {/* inferior */}

              <ul>
                <hr className="divider"></hr>
                <li>
                  {/* <button
                   className="check_button" 
                   type="button">
                    <i
                      className="fas fa-check-circle"></i>
                  </button> */}
                  <a href="/prepararviagem#1" className="right mx-auto">
                    <p className="mt-1">{t('moduleToDoList:S1.UL.LI1')}</p>
                    <div className="arrow-color">
                      <i className="fas fa-chevron-right"></i>
                    </div>
                  </a>
                </li>

                <hr className="divider"></hr>

                <li>
                  {/* <button
                  className="check_button" 
                  type="button">
                    <i
                      className="fas fa-check-circle"></i>
                  </button> */}
                  <a href="/prepararviagem#2" className="right mx-auto">
                    <p className="mt-1">{t('moduleToDoList:S1.UL.LI2')}</p>
                    <div className="arrow-color">
                      <i className="fas fa-chevron-right"></i>
                    </div>
                  </a>
                </li>

                <hr className="divider"></hr>

                <li>
                  {/* <button
                  className="check_button" 
                  type="button">
                    <i
                      className="fas fa-check-circle"></i>
                  </button> */}
                  <a href="/prepararviagem#3" className="right mx-auto">
                    <p className="mt-1">{t('moduleToDoList:S1.UL.LI3')}</p>
                    <div className="arrow-color">
                      <i className="fas fa-chevron-right"></i>
                    </div>
                  </a>
                </li>

                <hr className="divider"></hr>

                <li>
                  {/* <button
                  className="check_button" 
                  type="button">
                    <i
                      className="fas fa-check-circle"></i>
                  </button> */}
                  <a href="/prepararviagem#4" className="right mx-auto">
                    <p className="mt-1">{t('moduleToDoList:S1.UL.LI4')}</p>
                    <div className="arrow-color">
                      <i className="fas fa-chevron-right"></i>
                    </div>
                  </a>
                </li>

                <hr className="divider"></hr>

                <li>
                  {/* <button
                  className="check_button" 
                  type="button">
                    <i
                      className="fas fa-check-circle"></i>
                  </button> */}
                  <a href="/prepararviagem#5" className="right mx-auto">
                    <p className="mt-1">{t('moduleToDoList:S1.UL.LI5')}</p>
                    <div className="arrow-color">
                      <i className="fas fa-chevron-right"></i>
                    </div>
                  </a>
                </li>

                <hr className="divider"></hr>

                <li>
                  {/* <button
                  className="check_button" 
                  type="button">
                    <i
                      className="fas fa-check-circle"></i>
                  </button> */}
                  <a href="/prepararviagem#5" className="right mx-auto">
                    <p className="mt-1">{t('moduleToDoList:S1.UL.LI6')}</p>
                    <div className="arrow-color">
                      <i className="fas fa-chevron-right"></i>
                    </div>
                  </a>
                </li>

                <hr className="divider"></hr>

                <li>
                  {/* <button
                  className="check_button" 
                  type="button">
                    <i
                      className="fas fa-check-circle"></i>
                  </button> */}
                  <div className="right mx-auto">
                    <p className="mt-1">{t('moduleToDoList:S1.UL.LI7')}</p>
                  </div>
                </li>

                <hr className="divider"></hr>

                <li>
                  {/* <button
                  className="check_button" 
                  type="button">
                    <i
                      className="fas fa-check-circle"></i>
                  </button> */}
                  <a
                    href="https://www.google.com/flights"
                    rel="noreferrer"
                    className="right mx-auto"
                    target="_blank"
                  >
                    <p className="mt-1">{t('moduleToDoList:S1.UL.LI8')}</p>
                    <div className="arrow-color">
                      <i className="fas fa-chevron-right"></i>
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
    </>
  );
};
export default withNamespaces() (Preparar);
